import { Component, HostListener, Inject } from '@angular/core';
import { MatDialog } from '@angular/material';
import { DialogCookieConfirm } from './components/utilita/dialogs/dialog-cookie-confirm/dialog-cookie-confirm.component';
import { MyCookieService } from './services/my-cookie.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent 
{
  myCookieService: MyCookieService;

  constructor(
    @Inject(MyCookieService) myCookieService: MyCookieService,
    private dialog: MatDialog)
  {
    if(environment.test_env){
      console.warn('Ambiente di test !!!');
    }
    this.myCookieService = myCookieService;
    if(!this.myCookieService.cPref && !this.myCookieService.reloaded){
      let dialogRef = this.dialog.open(DialogCookieConfirm, {disableClose: true});
      dialogRef.afterClosed().subscribe(
        () => {
          if(this.myCookieService.change === true){
            this.myCookieService.reloaded = true;
            location.reload();
          }
        }
      );
    }
    if(environment.production && this.myCookieService.google){
      this.appendGaTrackingCode();
    }
  }

  private appendGaTrackingCode() {
    try {
      const script = document.createElement('script');
      script.innerHTML = `(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
        (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
        m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
        })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
        ga('create', '` + environment.ga_track + `', 'auto');`;
      document.head.appendChild(script);
    } catch (ex) {
     console.error('Error appending google analytics');
     console.error(ex);
    }
  }

  // La funzione BACK sul tasto BACKSAPCE è disabilitata
  @HostListener('document:keydown', ['$event'])
  onKeyDown(evt: KeyboardEvent) {
    let target:any = evt.target;
    if (
      evt.which === 8 &&
      (target.nodeName != 'INPUT' && target.nodeName != 'SELECT'
        && target.nodeName != 'TEXTAREA')
    ) { 
      evt.preventDefault();
    }
  }

}



// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/app.component.ts